import script from "./UpdateAssetAdminCard.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateAssetAdminCard.vue?vue&type=script&setup=true&lang=js"

import "./UpdateAssetAdminCard.vue?vue&type=style&index=0&id=4a685c9f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a685c9f"]])

export default __exports__